module.exports = __webpack_public_path__ + "img/10th_college.c2e75260.webp";